var React = require('react');

function UnlockContentIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20 28.883v10.234a.5.5 0 0 0 .757.429l8.528-5.117a.5.5 0 0 0 0-.858l-8.528-5.117a.5.5 0 0 0-.757.43z","fill":"#8D6CFF","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33 13v1a2 2 0 1 0 4 0v-1c0-7.18-5.82-13-13-13S11 5.82 11 13v7H7a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h34a3 3 0 0 0 3-3V23a3 3 0 0 0-3-3H15v-7a9 9 0 1 1 18 0zm7 11v20H8V24h32z","fill":"#8D6CFF","key":1})]);
}

UnlockContentIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = UnlockContentIcon;

UnlockContentIcon.default = UnlockContentIcon;
